var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <option value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"key") : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"value") : depth0), depth0))
    + "</option>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label for=\"sectors\" class=\"form-label visually-hidden\">"
    + alias2(__default(require("../../../handlebars/helpers/translate.ts")).call(alias1,"sector",{"name":"translate","hash":{"label":(depth0 != null ? lookupProperty(depth0,"label") : depth0)},"data":data,"loc":{"start":{"line":1,"column":56},"end":{"line":1,"column":90}}}))
    + "</label>\n<select id=\"sectors\" class=\"form-select\" name=\"filter[sectors]\">\n    <option value=\"\" selected>"
    + alias2(__default(require("../../../handlebars/helpers/translate.ts")).call(alias1,"allSectors",{"name":"translate","hash":{"label":(depth0 != null ? lookupProperty(depth0,"label") : depth0)},"data":data,"loc":{"start":{"line":3,"column":30},"end":{"line":3,"column":68}}}))
    + "</option>\n\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"filters") : depth0)) != null ? lookupProperty(stack1,"sectors") : stack1)) != null ? lookupProperty(stack1,"values") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":7,"column":13}}})) != null ? stack1 : "")
    + "</select>\n";
},"useData":true});